import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQAccordion = ({ faqs }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        
        return (
          <div
            key={faq.id || index}
            className="glass-card"
            style={{
              padding: '0',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onClick={() => toggleFAQ(index)}
          >
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '24px',
              gap: '20px'
            }}>
              <h3 style={{
                fontSize: '18px',
                fontWeight: '600',
                color: '#1a202c',
                margin: 0,
                flex: 1
              }}>
                {faq.question}
              </h3>
              <div style={{
                flexShrink: 0,
                color: '#0891B2',
                transition: 'transform 0.3s ease'
              }}>
                {isOpen ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
              </div>
            </div>
            
            {isOpen && (
              <div style={{
                padding: '0 24px 24px 24px',
                borderTop: '1px solid #E2E8F0',
                paddingTop: '16px',
                animation: 'fade-in-up 0.3s ease-out'
              }}>
                <p style={{
                  fontSize: '16px',
                  lineHeight: '1.7',
                  color: '#4a5568',
                  margin: 0
                }}>
                  {faq.answer}
                </p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default FAQAccordion;
